<template>
    <div v-if="additionals">
        <rkm-form
            ref="RkmFormCampanha"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        v-model="model.nome"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        :end-validations="validations.periodo.ate"
                        :range-inline="false"
                        :start-validations="validations.periodo.de"
                        end-label="Até"
                        range
                        right
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.vacina"
                        :search-fields="fields.autocomplete"
                        :text-field="item => item.id ? `${autocompleteTextField(item)}` : item.nome"
                        :validations="validations.vacina"
                        label="Vacina"
                        v-model="model.vacina"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.meta"
                        label="Meta (%)"
                        type="number"
                        v-model="model.meta"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-form ref="RkmFormCampanhaPopulacao">
            <rkm-area
                title="População"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.idadeInicial"
                            label="Idade inicial"
                            type="number"
                            v-model="local.idadeInicial"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        :options="form.medidasTempo"
                                        text-field="nome"
                                        v-model="local.idadeInicialMedidaTempoId"
                                        value-field="id"
                                    />
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.idadeFinal"
                            label="Idade final"
                            type="number"
                            v-model="local.idadeFinal"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        :options="form.medidasTempo"
                                        text-field="nome"
                                        v-model="local.idadeFinalMedidaTempoId"
                                        value-field="id"
                                    />
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="form.sexos"
                            default-option-text="AMBOS"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="local.sexoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :disabled="!local.idadeInicial && !local.idadeFinal && !local.sexoId"
                            :label="false"
                            @click="includePopulacao"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :disabled="!local.idadeInicial && !local.idadeFinal && !local.sexoId"
                            :label="false"
                            @click="resetFormPopulacao"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="fields.table"
                            :items="model.populacoes"
                            ref="RkmTablePopulacao"
                        >
                            <template v-slot:cell(idadeInicial)="row">
                                {{ row.item.idadeInicial }} - {{ row.item.idadeInicialMedidaTempoNome }}
                            </template>

                            <template v-slot:cell(idadeFinal)="row">
                                {{ row.item.idadeFinal }} - {{ row.item.idadeFinalMedidaTempoNome }}
                            </template>

                            <template v-slot:cell(actions)="{ index }">
                                <rkm-button
                                    @click="destroyPopulacao(index)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>
// Enums.
import medidaTempo from '@/enums/cadastro/medidaTempo'
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            const autocomplete = []

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                default:
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;
            }

            return {
                autocomplete,
                table: [
                    { key: 'idadeInicial', label: 'Idade inicial' },
                    { key: 'idadeFinal', label: 'Idade final' },
                    { key: 'sexoDescricao', label: 'Sexo' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ],
            }
        },
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                periodo: {
                    de: { required: true },
                    ate: { required: true },
                },
                periodoAte: { required: true },
                vacina: { required: true },
                meta: {
                    required: true,
                    min_value: 1,
                    max_value: 100,
                },
                idadeInicial: {
                    required: true,
                    min_value: 0,
                    max_value: 366,
                },
                idadeFinal: {
                    required: true,
                    min_value: this.local.idadeInicial ? this.local.idadeInicial : 0,
                    max_value: 366,
                },
            }
        },
    },
    created() {
        this.repositories = {
            cadastroCampanha: this.getConectaSusRepository('imunizacao.cadastroCampanha'),
            vacina: this.getConectaSusRepository('cadastro.vacina'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { medidaTempo, parametrizacaoDescricaoVacina },
        form: null,
        local: {
            idadeInicial: null,
            idadeInicialMedidaTempoId: medidaTempo.ANOS,
            idadeFinal: null,
            idadeFinalMedidaTempoId: medidaTempo.ANOS,
            sexoId: null,
        },
        model: null,
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.cadastroCampanha.edit(this.id)
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.cadastroCampanha.create()
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        includePopulacao() {
            this.$refs.RkmFormCampanhaPopulacao.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.local.idadeInicialMedidaTempoId === this.enums.medidaTempo.MESES) {
                        if (this.local.idadeFinalMedidaTempoId === this.enums.medidaTempo.DIAS) {
                            this.showValidationNotification('Se a idade inicial for em Mês(es) a idade final também deverá ser em Mês(es) ou Ano(s).')
                            return
                        }
                    }
                    else if (this.local.idadeInicialMedidaTempoId === this.enums.medidaTempo.ANOS) {
                        if (this.local.idadeFinalMedidaTempoId !== this.enums.medidaTempo.ANOS) {
                            this.showValidationNotification('Se a idade inicial for em Anos(s) a idade inicial também deverá ser em Anos(s).')
                            return
                        }
                    }

                    const idadeInicialMedidaTempo = this.form.medidasTempo.find(medidaTempo => medidaTempo.id === this.local.idadeInicialMedidaTempoId)
                    const idadeFinalMedidaTempo = this.form.medidasTempo.find(medidaTempo => medidaTempo.id === this.local.idadeFinalMedidaTempoId)
                    const sexo = this.form.sexos.find(sexo => sexo.id === this.local.sexoId)

                    const populacao = {
                        idadeInicial: this.local.idadeInicial,
                        idadeInicialMedidaTempoId: idadeInicialMedidaTempo.id,
                        idadeInicialMedidaTempoNome: idadeInicialMedidaTempo.nome,
                        idadeFinal: this.local.idadeFinal,
                        idadeFinalMedidaTempoId: idadeFinalMedidaTempo.id,
                        idadeFinalMedidaTempoNome: idadeFinalMedidaTempo.nome,
                        sexoId: sexo ? sexo.id : null,
                        sexoDescricao: sexo ? sexo.descricao : 'AMBOS',
                    }

                    this.model.populacoes.push(populacao)
                    this.resetFormPopulacao()
                })
        },
        destroyPopulacao(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a população?', async () => this.model.populacoes.splice(index, 1))
        },
        save() {
            this.$refs.RkmFormCampanha.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.populacoes.length === 0) {
                        this.showValidationNotification('Obrigatório incluir pelo menos uma população.')
                        return
                    }

                    this.setLoading()

                    const campanha = {
                        nome: this.model.nome,
                        periodoDe: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                        periodoAte: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        vacinaId: this.model.vacina.id,
                        meta: this.model.meta,
                        populacoes: this.model.populacoes.map(populacao => {
                            return {
                                idadeInicial: populacao.idadeInicial,
                                idadeInicialMedidaTempoId: populacao.idadeInicialMedidaTempoId,
                                idadeFinal: populacao.idadeFinal,
                                idadeFinalMedidaTempoId: populacao.idadeFinalMedidaTempoId,
                                sexoId: populacao.sexoId,
                            }
                        }),
                    }

                    if (this.model.id) {
                        this.repositories.cadastroCampanha
                            .update(this.model.id, this.camelObjectKeysToSnakeRecursive(campanha))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.cadastroCampanha.store(this.camelObjectKeysToSnakeRecursive(campanha))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        resetFormPopulacao() {
            this.local.idadeInicial = null
            this.local.idadeInicialMedidaTempoId = this.enums.medidaTempo.DIAS
            this.local.idadeFinal = null
            this.local.idadeFinalMedidaTempoId = this.enums.medidaTempo.DIAS
            this.local.sexoId = null

            this.$refs.RkmFormCampanhaPopulacao.resetValidator()
        },
        autocompleteTextField(item) {

            let textField = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    textField = `${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = `${item.sigla}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    textField = `${item.sigla} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    textField = `${item.sigla} - ${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.abreviacao} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.sigla} - ${item.abreviacao} - ${item.nome}`
                    break;

                default:
                    textField = `${item.nome}`
                    break;
            }

            return textField
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>